module.exports = __webpack_public_path__ + "static/media/craft_item_set.91afa63e.mp3";